<script>
  import parseData from "./data.js";
  import Options from "./components/Options.svelte";
  import Chart from "./components/Chart.svelte";

  const init = () => {
    resize(mq);
  };

  const tripsFile = "032621-trips.csv"
  const refsFile = "030821-ref.csv"
  let dataDir = "./data/"

  if (window.location.href.indexOf('chinapower') != -1) {
    dataDir = '../interactives/china-diplomacy/'
  }

  const dataSrc = {
    trips: dataDir + tripsFile,
    ref: dataDir + refsFile,
  };

  const data = loadData();

  async function loadData() {
    let res = await parseData({
      src: dataSrc,
    });

    setupObserver();
    return res;
  }

  let observed = false;

  const sections = {
    mainChart() {
      observed = true;
      return;
    },
  };

  let selectedYear = 2020;
  let selectedIndicator = "region";
  let colorBy = "region";

  let isMobile = false;
  let mq = window.matchMedia("(max-width: 48em)");

  function resize(mediaQueryList) {
    if (mediaQueryList.matches) {
      isMobile = true;
    } else {
      isMobile = false;
    }
  }

  mq.addListener(resize);

  const setupObserver = () => {
    if (
      !("IntersectionObserver" in window) ||
      !("IntersectionObserverEntry" in window) ||
      !("intersectionRatio" in window.IntersectionObserverEntry.prototype)
    ) {
      for (let section in sections) {
        sections[section]();
      }
    }

    const triggers = document.querySelectorAll(".section__trigger");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, i) => {
          const id = entry.target.getAttribute("data-section");
          if (entry.intersectionRatio > 0) {
            sections[id]();
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    triggers.forEach((trigger) => {
      observer.observe(trigger);
    });
  };

  window.addEventListener("DOMContentLoaded", init);
</script>

<main class="interactive">
  <div class="interactive__header">
    <h1>Visualizing the Diplomatic Activities of Top Chinese Officials</h1>
    <p>
      This interactive visualizes overseas trips taken by top Chinese officials
      from 2014 to 2020. Virtual meetings hosted or co-hosted by foreign
      countries are also shown. Each solid stem represents a single trip, and
      dashed stems denote virtual meetings. A trip can include visits to
      multiple countries, and bubbles are sized based on the number of countries
      visited during a trip. Hover over a bubble to reveal more details. View
      data from a different year by selecting from the drop-down menu. You can
      also toggle between viewing the data by region or income level.
    </p>
  </div>

  <div
    class={isMobile === false ? "section__trigger" : ""}
    data-section="mainChart"
  />
  {#await data}
    <div class="loading-container">
      <div class="loading" />
    </div>
  {:then allData}
    <Options
      years={allData.years}
      bind:selectedYear
      bind:selectedIndicator
      bind:colorBy
    />

    <Chart
      {allData}
      {selectedYear}
      {selectedIndicator}
      {colorBy}
      {observed}
      {isMobile}
    />

    <footer class="interactive__source">
      <a href="https://chinapower.csis.org" class="source-holder"
        ><img
          src="./images/cpp-logo-red.svg"
          target="_blank"
          alt="ChinaPower Project"
          title="ChinaPower Project"
        /></a
      >
      <div class="source-details">
        <p>
          Source:
          <a
            href="https://www.fmprc.gov.cn/web/wjdt_674879/wsrc_674883/"
            target="_blank"
            alt="Chinese Ministry of Foreign Affairs"
            >Chinese Ministry of Foreign Affairs</a
          >
        </p>
      </div>
    </footer>
  {:catch error}
    <p style="color: red">{error.message}</p>
  {/await}
</main>

<style type="text/scss">
  @import "./scss/layout/_base.scss"; 
  @import "./scss/components/_header.scss";
  @import "./scss/components/_source.scss";
  @import "./scss/components/_loading.scss";
</style>
